export const status = {
  active: '啟用',
  inactive: '停用',
  available: '可用',
  occupied: '使用中',
  offline: '離線',
  maintenance: '維護中',
  error: '錯誤',
  charging: '充電中',
  completed: '已完成',
  cancelled: '已取消',
  pending: '待處理',
};